import React from 'react';
import { useTheme } from 'styled-components';
import { ColorSet } from 'src/theme/colors';

interface Props {
  color?: keyof ColorSet;
  style?: React.CSSProperties;
}

export const CheckIcon: React.FC<Props> = ({ color = 'cflowerBlue', style }) => {
  const colors = useTheme().colors;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" style={style}>
      <rect
        x="0.807692"
        y="0.807692"
        width="19.3846"
        height="19.3846"
        rx="9.69231"
        fill={colors[color]}
        stroke={colors[color]}
        strokeWidth="1.61538"
      />
      <path
        d="M7.97797 13.0426L5.0309 10.0956L4.02734 11.0921L7.97797 15.0427L16.4587 6.56192L15.4622 5.56543L7.97797 13.0426Z"
        fill="white"
      />
    </svg>
  );
};
